export default "__VITE_ASSET__BFrPV_8x__"